import { Modal, message, notification } from 'antd';

export default class CustomResponse {

  _alertTimeouts = {};

  constructor(response) {
    /* 继承response的所有属性 */
    for (const prop in response) {
      this[prop] = response[prop]
    }
  }

  /**
   * @name 弹出成功消息，在右下角弹出
   * @param {String} msg 弹出的消息
   */

  _notification(msg, type="error",duration) {
    const timeoutKey = setTimeout(()=>{
      delete this._alertTimeouts[timeoutKey];
      const msgText = msg || this.data.msg
      msgText && notification[type]({
        description: msgText,
        duration: duration || 2
      });
    },10)
    this._alertTimeouts[timeoutKey] = true;
    return timeoutKey;
  }

  msg(msg, type = "error") {
    const timeoutKey = setTimeout(()=>{
      delete this._alertTimeouts[timeoutKey];
      const msgText = msg || this.data.msg
      message[type](msgText);
    },10)
    this._alertTimeouts[timeoutKey] = true;
    return timeoutKey;
  }
  /**
   * @name 弹出错误消息，但不会马上弹出，可以通过cancelAlert取消 
   * @param {String} msg 弹出的消息，如果没有，则取this.data.msg
   */
  alert(msg) {
    const timeoutKey = setTimeout(()=>{
      delete this._alertTimeouts[timeoutKey];
      const msgText = msg || this.data.msg
      msgText && Modal.error({
        title: msgText,
        okType: 'default',
        okText: '关闭',
      });
    },10);
    this._alertTimeouts[timeoutKey] = true;
    return timeoutKey;
  }
  /**
   * 
   * @param {number} timeoutKey alert()返回的setTimeout标识符，如果没有则取消所有的alert
   */
  cancelAlert(timeoutKey) {
    if(timeoutKey) {
      clearTimeout(timeoutKey);
      delete this._alertTimeouts[timeoutKey];
      return;
    }

    for (const key in this._alertTimeouts) {
      clearTimeout(key);
    }

    this._alertTimeout = {};
  }
}


// WEBPACK FOOTER //
// ./src/service/CustomResponse.js